"use strict";

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ClassPlugin =
/*#__PURE__*/
function () {
  function ClassPlugin(transcriber) {
    _classCallCheck(this, ClassPlugin);

    this.m_Transcriber = transcriber;
  }

  _createClass(ClassPlugin, [{
    key: "Transcribe",
    value: function Transcribe() {
      var _this = this;

      this.m_Transcriber.TraverseMethod(function (methods, class_name) {
        return methods.forEach(function (method) {
          return _this.m_Transcriber.GetClass(class_name).AddMember(method.ToClassMethod());
        });
      });
    }
  }]);

  return ClassPlugin;
}();

exports.ClassPlugin = ClassPlugin;